import { createContext } from 'react';

import { AccordionContextValue } from '../types';

const AccordionContext = createContext<AccordionContextValue | null>(null);

export default AccordionContext;
